/** Socket.IO endpoint — Phase 1H / ADR-016 */

const DEFAULT_REALTIME_URL = 'ws://localhost:3001';

/** REST poll only while the socket is down. Live sockets invalidate queries directly. */
export function realtimeFallbackPollMs(live: boolean, fallbackMs: number): number | false {
  return live ? false : fallbackMs;
}

/** Localhost only in development. Production builds must set VITE_REALTIME_URL. */
export function resolveRealtimeUrl(
  fromEnv: string | undefined,
  isProductionBuild: boolean,
): string {
  if (typeof fromEnv === 'string' && fromEnv.length > 0) {
    return fromEnv;
  }
  if (isProductionBuild) {
    return '';
  }
  return DEFAULT_REALTIME_URL;
}

export function getRealtimeUrl(): string {
  return resolveRealtimeUrl(
    import.meta.env.VITE_REALTIME_URL as string | undefined,
    Boolean(import.meta.env.PROD),
  );
}

/** When false, clients skip Socket.IO entirely (no handshake spam). */
export function isRealtimeEnabled(): boolean {
  const flag = import.meta.env.VITE_REALTIME_ENABLED;
  if (typeof flag === 'string' && /^(0|false|off|no)$/i.test(flag.trim())) {
    return false;
  }
  const url = getRealtimeUrl().trim();
  return url.length > 0;
}

/** HTTP origin used to probe `/live` before opening a socket. */
export function getRealtimeHttpOrigin(url = getRealtimeUrl()): string {
  return url.replace(/^ws:/, 'http:').replace(/^wss:/, 'https:').replace(/\/$/, '');
}

export { DEFAULT_REALTIME_URL };
